import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalUtils } from '../utils/modal-utils';
import { SelectLocationDisplaysModalComponent } from '../views/display/components/modals/select-location-displays-modal/select-location-displays-modal.component';

export class ModalSelectLocationDisplays {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    onCloseIfNotCancelled: (args: { locationId: number; displayIds: string[] }) => void
  ): void {
    ngZone.run(() => {
      const modalRef = ngbModal.open(SelectLocationDisplaysModalComponent, ModalUtils.defaultModalOptions(injector));
      modalRef.result
        .then((args: { locationId: number; displayIds: string[] }) => {
          if (Number.isFinite(args?.locationId) || args?.displayIds?.length) {
            onCloseIfNotCancelled(args);
          }
        })
        .catch(() => {});
    });
  }
}
